<template>
	<div class="body-block">
		<slot />
	</div>
</template>

<script>
export default {
	name: "Empty"
}
</script>
